const rootConst = 'ADMIN_CUSTOM_PLAN';

export const GET_CUSTOM_PLAN_LIST = `${rootConst}/GET_CUSTOM_PLAN_LIST`;
export const GET_SELECTED_CUSTOM_PLAN = `${rootConst}/GET_SELECTED_CUSTOM_PLAN`;

export const CREATE_CUSTOM_PLAN = `${rootConst}/CREATE_CUSTOM_PLAN`;
export const UPDATE_CUSTOM_PLAN = `${rootConst}/UPDATE_CUSTOM_PLAN`;
export const REMOVE_CUSTOM_PLAN = `${rootConst}/REMOVE_CUSTOM_PLAN`;
export const GET_SUBCRIPTION_PLANS = `${rootConst}/GET_SUBCRIPTION_PLANS`;

export const OPTION_TIME_DURATION = [
  {
    label: '30 days',
    value: 30,
  },
  {
    label: '60 days',
    value: 60,
  },
  {
    label: '90 days',
    value: 90,
  },
  {
    label: '6 months',
    value: 183,
  },
  {
    label: '1 year',
    value: 365,
  },
];

export const OPTION_SORT_BY = [
  {
    label: 'ASCENDING',
    value: 'asc',
  },
  {
    label: 'DESCENDING',
    value: 'desc',
  },
];

export const OPTION_ORDER_BY = [
  {
    label: 'CREATED AT',
    value: 'created_at',
  },
  {
    label: 'SUSBCRIPTION NAME',
    value: 'name',
  },
];

export const INIT_FORM = {
  name: '',
  expiration_days: '',
  is_lifetime: false,
  subscription_plan_uuid: '',
};
